export const officeSignUp = {
  SignUpWelcomeMessage:
    "Welcome {{- firstName}} {{- lastName}}! You have been invited to join {{- storeName}}. Activate your account to get started.",
  CreatePassword: "Create password",
  ActivateAccount: "Activate account",
} as const;
